import Checkbox from "@/components/common/checkbox/Checkbox.vue";

export { Checkbox };
